<template>
  <div class="page-container">
    <nav-bar></nav-bar>
    <div class="page">
      <div class="container-fluid">
        <div class="card">
          <div class="card-body">
            <div class="title-coontainer">
              <h5 class="card-title">Feedbacks ({{ count }})</h5>
              <div class="filters-cont">
                <pager :limit="limit" @onPageChanged="onPageChanged"></pager>
                <div
                  style="margin-left: 1rem"
                  title="Download Data"
                  class="bt-filters"
                  @click="downloadData"
                >
                  <img src="../assets/ic_download.png" alt="" />
                </div>
              </div>
            </div>

            <div class="empty" v-if="feedbacks.length <= 0">
              <img src="../assets/empty.svg" />
              <span>No data to show ...</span>
            </div>

            <table class="table table-striped" v-else>
              <thead>
                <tr>
                  <th scope="col">Name</th>
                  <th scope="col">City</th>
                  <th scope="col">Rating</th>
                  <th scope="col">Message</th>
                </tr>
              </thead>
              <tbody>
                <tr v-bind:key="item.id" v-for="item in feedbacks">
                  <td>{{ item.name }}</td>
                  <td>{{ item.city }}</td>
                  <td>{{ item.score }}</td>
                  <td>{{ item.message }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavBar from "../components/NavBar";
import { HTTP, URLS } from "../network/http";
import Pager from "../components/Pager";
var NotificationsController = require("../components/NotificationsController.js");
const ExcelExporter = require("../utils/excel");

import moment from "moment";
export default {
  name: "Feedback",
  components: {
    NavBar,
    Pager,
  },
  data() {
    return {
      keyword: "",
      resultsPerPage: 10,
      count: 0,
      page: 1,
      limit: 0,
      feedbacks: [],
    };
  },
  methods: {
    downloadData() {
      ExcelExporter.JSONToCSVConvertor(this.feedbacks, "FeedBacks", true);
    },
    isFilterEmpty() {
      return Object.keys(this.filters).length != 0;
    },
    onPageChanged(page) {
      this.page = page;
      this.getFeedbacks();
    },
    getFeedbacks() {
      NotificationsController.showActivityIndicator();
      const ctx = this;
      var url = URLS.FEEDBACK.LIST;
      url = url + "?limit=" + this.resultsPerPage;
      url = url + "&page=" + this.page;

      HTTP.get(url)
        .then((response) => {
          let data = response.data;
          let rows = data.rows;
          ctx.count = data.count;
          let limit = Math.ceil(data.count / ctx.resultsPerPage);
          ctx.limit = limit;
          ctx.previousEnable = limit > 0;
          ctx.nextEnable = ctx.page < limit;
          ctx.feedbacks = rows;
          NotificationsController.hideActivityIndicator();
        })
        .catch((err) => {
          NotificationsController.hideActivityIndicator();
        });
    },
  },
  mounted() {
    this.getFeedbacks();
    this.moment = moment;
  },
};
</script>

<style lang="scss">
.page-container {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;

  nav-bar {
    height: 100px;
    width: 100%;
  }

  .page {
    width: 100%;
    height: 90%;
    overflow-y: scroll;
  }

  .title-coontainer {
    width: 100%;
    display: flex;
    flex-direction: row;
    margin-bottom: 10px;
    align-items: center;

    .filters-cont {
      display: flex;
      flex-direction: row;
      button {
        margin-right: 10px;
      }
    }
  }
}

.table-card {
  box-shadow: 0px 0px 10px 0px #bdbdbd;
}

.actions {
  button {
    margin-right: 4px;
  }
}
</style>
